module.exports = __webpack_public_path__ + "static/media/banner.42af5e61.png";